import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EhCoursePage } from './eh-course.page';

const routes: Routes = [
  {
    path: '',
    component: EhCoursePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EhCoursePageRoutingModule {}
